import { gql } from 'apollo-boost';

export const PULL_URL_MARKDOWN = gql`
    mutation($data: PullUrlMarkdownInput!) {
        pullUrlMarkdown(data: $data)
    }
`;

